import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Checkbox from 'components/checkbox';
import React from 'react';

const useStyles = makeStyles((theme: any) => ({
  title: { color: theme.palette.tab.offselected },
  subtitle: {
    color: theme.palette.primary.main,
    fontWeight: 500,
  }
}));

type Option = {
  label: string;
  value: boolean | string;
  disabled: boolean;
};

type Props = {
  title?: string;
  description?: string;
  options: Option[];
  value: boolean | string | null;
  onChange: (value: boolean | string | null) => void;
  onSave?: () => void;
  onBlur?: () => void;
};

export function OptionalChoiceForm({
  title,
  description,
  options,
  value,
  onChange,
  onSave,
  onBlur
}: Props) {
  const classes = useStyles();

  const handleCheckboxChange = (optionValue: boolean | string) => (e: any, checked: boolean) => {
    if (checked) {
      onChange(optionValue);
    } else {
      onChange(null);
    }
    if (onSave) onSave();
  };

  return (
    <Box style={{ flex: 1 }} onBlur={onBlur}>
      {title && (
        <Typography variant="h6" className={classes.title}>
          {title}
        </Typography>
      )}

      {description && (
        <Typography variant="body2" className={classes.subtitle}>
          {description}
        </Typography>
      )}

      <Box style={{ display: 'flex', flexDirection: 'column' }}>
        {options.map((option) => (
          <Checkbox
            key={String(option.value)}
            size="small"
            label={option.label}
            checked={option.value === value}
            handleOnChange={handleCheckboxChange(option.value)}
            disabled={option.disabled}
          />
        ))}
      </Box>
    </Box>
  );
}
